var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import { jsx as _jsx } from "react/jsx-runtime";
import { Suspense } from "react";
import { Spinner } from "components/authComponents/Spinner";
import { DEFAULT_PROFILE_TAB, PROFILE_BASE_PATH, PROFILE_TAB_VALUES, } from "components/profile/Main/subcomponents/ProfileTabs/ProfileTabs.constants";
import { AdminGuard, SuperAdminRoute } from "features/admin";
import { AuctionList, AuctionForm, AuctionBids } from "features/admin/auctions";
import { CoinImageManager } from "features/admin/coins";
import { CollectionList, CollectionWizard, CollectionDetail, NftList, NftWizard, AllItems, AllHolders, AllActivity, } from "features/admin/collections";
import { DocumentCard, DocumentList } from "features/admin/documents";
import { OffersList } from "features/admin/offers";
import { PlatformFeeSettings, WithdrawalHistory } from "features/admin/platform";
import { TokenList, TokenWizard, TokenDetail } from "features/admin/tokens";
import AuthLayout from "layouts/AuthLayout";
import { GoogleCallback, ChangePassword, LogIn, EmailVerifycation, AuthPage, MainTrade, Profile, CreatingAccount, EmailVerifycationCode, PasswordCreation, UserResidensy, PersonalInformation, HomeAdress, KYCSelect, KYCInfo, KYCDoc, KYCPerson, SuccesfullOperation, CollectionsPage, MapPage, TokenPage, AdminPage, } from "pages";
import NotFoundPage from "pages/notFoundPage/NotFoundPage";
import { createBrowserRouter, Navigate, RouterProvider } from "react-router";
import { ProtectedRoute } from "./ProtectedProfileRouter";
export var AppRouter = function (_a) {
    var currentLocale = _a.currentLocale, onLocaleChange = _a.onLocaleChange;
    var profileRouteElement = (_jsx(ProtectedRoute, { children: _jsx(Profile, {}) }));
    var router = createBrowserRouter(__spreadArray(__spreadArray([
        {
            path: "/",
            element: _jsx(Navigate, { to: "".concat(PROFILE_BASE_PATH, "/").concat(DEFAULT_PROFILE_TAB), replace: true }),
        },
        {
            path: PROFILE_BASE_PATH,
            element: _jsx(Navigate, { to: "".concat(PROFILE_BASE_PATH, "/").concat(DEFAULT_PROFILE_TAB), replace: true }),
        }
    ], PROFILE_TAB_VALUES.map(function (tabValue) { return ({
        path: "".concat(PROFILE_BASE_PATH, "/").concat(tabValue),
        element: profileRouteElement,
    }); }), true), [
        {
            path: "/auth",
            element: _jsx(AuthPage, { onLocaleChange: onLocaleChange, currentLocale: currentLocale }),
        },
        {
            path: "/auth",
            element: _jsx(AuthLayout, { onLocaleChange: onLocaleChange, currentLocale: currentLocale }),
            children: [
                { path: "login", element: _jsx(LogIn, {}) },
                { path: "email-verify", element: _jsx(EmailVerifycation, {}) },
                { path: "change-password", element: _jsx(ChangePassword, {}) },
                { path: "google/callback", element: _jsx(GoogleCallback, {}) },
            ],
        },
        {
            path: "/registration",
            element: _jsx(AuthPage, { onLocaleChange: onLocaleChange, currentLocale: currentLocale }),
        },
        {
            path: "/registration",
            element: _jsx(AuthLayout, { onLocaleChange: onLocaleChange, currentLocale: currentLocale }),
            children: [
                { path: "creating-account", element: _jsx(CreatingAccount, {}) },
                { path: "email", element: _jsx(EmailVerifycationCode, {}) },
                { path: "creating-password", element: _jsx(PasswordCreation, {}) },
                {
                    path: "residency",
                    element: (_jsx(ProtectedRoute, { children: _jsx(UserResidensy, {}) })),
                },
                {
                    path: "personal-information",
                    element: (_jsx(ProtectedRoute, { children: _jsx(PersonalInformation, {}) })),
                },
                {
                    path: "adress",
                    element: (_jsx(ProtectedRoute, { children: _jsx(HomeAdress, {}) })),
                },
            ],
        },
        {
            path: "/",
            element: _jsx(AuthLayout, { onLocaleChange: onLocaleChange, currentLocale: currentLocale }),
            children: [
                {
                    path: "kyc-select",
                    element: (_jsx(ProtectedRoute, { children: _jsx(KYCSelect, {}) })),
                },
                {
                    path: "kyc-info",
                    element: (_jsx(ProtectedRoute, { children: _jsx(KYCInfo, {}) })),
                },
                {
                    path: "kyc-doc",
                    element: (_jsx(ProtectedRoute, { children: _jsx(KYCDoc, {}) })),
                },
                {
                    path: "kyc-person",
                    element: (_jsx(ProtectedRoute, { children: _jsx(KYCPerson, {}) })),
                },
            ],
        },
        {
            path: "/success",
            element: _jsx(SuccesfullOperation, {}),
        },
        {
            path: "/home",
            element: (_jsx(Suspense, { fallback: _jsx(Spinner, {}), children: _jsx(MainTrade, {}) })),
        },
        {
            path: "/collection/:slug",
            element: (_jsx(Suspense, { fallback: _jsx(Spinner, {}), children: _jsx(CollectionsPage, {}) })),
        },
        {
            path: "/map",
            element: (_jsx(Suspense, { fallback: _jsx(Spinner, {}), children: _jsx(MapPage, {}) })),
        },
        {
            path: "/token/:symbol",
            element: (_jsx(Suspense, { fallback: _jsx(Spinner, {}), children: _jsx(TokenPage, {}) })),
        },
        {
            path: "/admin",
            element: (_jsx(AdminGuard, { children: _jsx(AdminPage, {}) })),
            children: [
                { index: true, element: _jsx(Navigate, { to: "/admin/documents", replace: true }) },
                { path: "documents", element: _jsx(DocumentList, {}) },
                { path: "documents/:id", element: _jsx(DocumentCard, {}) },
                { path: "coins", element: _jsx(CoinImageManager, {}) },
                {
                    path: "platform-fee",
                    element: (_jsx(SuperAdminRoute, { children: _jsx(PlatformFeeSettings, {}) })),
                },
                {
                    path: "withdrawals",
                    element: (_jsx(SuperAdminRoute, { children: _jsx(WithdrawalHistory, {}) })),
                },
                { path: "collections", element: _jsx(CollectionList, {}) },
                { path: "collections/create", element: _jsx(CollectionWizard, {}) },
                { path: "collections/:id", element: _jsx(CollectionDetail, {}) },
                { path: "collections/:id/edit", element: _jsx(CollectionWizard, {}) },
                { path: "collections/:collectionId/nfts", element: _jsx(NftList, {}) },
                { path: "collections/:collectionId/nfts/create", element: _jsx(NftWizard, {}) },
                { path: "collections/:collectionId/nfts/:nftId/edit", element: _jsx(NftWizard, {}) },
                // Tokens (house-tokens)
                { path: "tokens", element: _jsx(TokenList, {}) },
                { path: "tokens/create", element: _jsx(TokenWizard, {}) },
                { path: "tokens/:id", element: _jsx(TokenDetail, {}) },
                { path: "tokens/:id/edit", element: _jsx(TokenWizard, {}) },
                // Auctions
                { path: "auctions", element: _jsx(AuctionList, {}) },
                { path: "auctions/create", element: _jsx(AuctionForm, {}) },
                { path: "auctions/:id", element: _jsx(AuctionBids, {}) },
                { path: "auctions/:id/edit", element: _jsx(AuctionForm, {}) },
                // Offers moderation
                { path: "offers", element: _jsx(OffersList, {}) },
                // Глобальные агрегаты по всем коллекциям
                { path: "items", element: _jsx(AllItems, {}) },
                { path: "holders", element: _jsx(AllHolders, {}) },
                { path: "activity", element: _jsx(AllActivity, {}) },
            ],
        },
        {
            path: "*",
            element: _jsx(NotFoundPage, { currentLocale: currentLocale, onLocaleChange: onLocaleChange }),
        },
    ], false));
    return (_jsx(Suspense, { fallback: _jsx(Spinner, {}), children: _jsx(RouterProvider, { router: router }) }));
};
